import Vue from 'vue'
import axios from 'axios';
import qs from 'query-string';
import App from './App.vue'

const axiosInstance = axios.create({
  baseURL: `${window.settings.openApi.url}`,
  transformRequest: [
    (data, headers) => {
      headers['content-type'] = 'application/x-www-form-urlencoded';
      return data;
    }
  ]
});
axiosInstance.interceptors.request.use((request) => {
  if (request && typeof request.data === 'object') {
    for (let key in request.data ) {
      if (!request.data[key] && request.data[key] !== false && request.data[key] !== 0) {
        delete request.data[key];
      }
    }
  }

  request.data = qs.stringify(request.data);
  return request;
});
axiosInstance.interceptors.response.use((response) => {
  return response.data;
}, (error) => {
  const { response = {
    data: {
      error,
    },
  } } = error;
  return Promise.reject(response);
});

Vue.prototype.$http = Vue.http = axiosInstance;
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
